export function updateArrayElement<T>(array: T[], element: T): T[] {
  const index = array.indexOf(element);
  if (index === -1) {
    return array;
  }

  const arrayCopy = [...array];
  arrayCopy[index] = { ...element };
  return arrayCopy;
}
